export default __webpack_public_path__ + "static/link-01a-do-0d19023f988d6a00299bf2f36e13bad1.png";